<template>
  <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader"
                @submit="submit" @close-modal="closeModal" modal-size="large">
        <template slot="header">
            <h5 class="modal-title" id="ModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `leaves/${inputs.id}` : `leaves`'>
                <div class="row">
                    <div class="col-md-6">
                        <app-form-group
                            :label="$t('start_date')"
                            type="date"
                            v-model="inputs.start_date"
                            :placeholder="$t('start_date')"
                            :required="true"
                        />
                    </div>
                    <div class="col-md-6">
                        <app-form-group
                            :label="$t('end_date')"
                            type="date"
                            v-model="inputs.end_date"
                            :placeholder="$t('end_date')"
                        />
                    </div>
                    <!-- Employee Select Input -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="employee">
                                {{ $t('employee') }}
                                <span style="color: crimson">*</span>
                            </label>
                            <app-input class="w-100" id="employee" v-model="inputs.employee_id" 
                                    :list="employeeList" list-value-field="name" :placeholder="$t('choose_one')" 
                                    type="search-select" :required="true" />
                        </div>
                    </div>
                    <!-- Leave Type Select Input -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="leave_type">
                                {{ $t('leave_type') }}
                                <span style="color: crimson">*</span>
                            </label>
                            <app-input class="w-100" id="leave_type" v-model="inputs.leave_type_id" 
                                    :list="leaveTypeList" list-value-field="name" :placeholder="$t('choose_one')" 
                                    type="search-select" :required="true" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <!-- Marital Status Input -->
                        <div class="form-group">
                            <label for="status">{{ $t('status') }} 
                                <span style="color: crimson">*</span>
                                </label>
                            <app-input class="w-100" id="status" v-model="inputs.status"
                                :list="statusList" :placeholder="$t('status')" type="select"
                                :required="true" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <app-form-group
                            :label="$t('reason')"
                            type="textarea"
                            v-model="inputs.reason"
                            :placeholder="$t('reason')"
                        />
                    </div>
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
        </template>
    </app-modal>
</template>

<script>
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import {errorMessageForArray} from '../../../../common/Helper/Support/FormHelper';
import {formatDateForServer} from "../../../../common/Helper/Support/DateTimeHelper";
import { ModalMixin } from '../../../Mixins/ModalMixin';
import {mapState} from 'vuex';

export default {
    name: 'LeaveAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
    },
    computed: {
        ...mapState({
            employeeList: state => state.selects.employeeList,
            leaveTypeList: state => state.selects.leaveTypeList,
        })
    },
    data() {
        return {
            errorMessageForArray,
            preloader: false,
            modalId: 'leave-add-edit-modal',
            inputs: {
                name: '',
                description: '',
            },
            isModalActive: false,
            modalTitle: `${this.$t('new-leave')}`,
            statusList: [
                {
                    id: 'pending',
                    value: this.$t('pending')
                },
                {
                    id: 'approved',
                    value: this.$t('approved')
                },
                {
                    id: 'rejected',
                    value: this.$t('rejected')
                },
            ],
        }
    },
    methods: {
        submit() {
            let formData = this.inputs;

            formData.start_date = formatDateForServer(formData.start_date);
            formData.end_date = formatDateForServer(formData.end_date);

            this.save(formData);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData({ data }) {
            this.inputs = data;
            this.inputs.start_date = data.start_date ? new Date(data.start_date) : '';
            this.inputs.end_date = data.end_date ? new Date(data.end_date) : '';
            this.preloader = false;
        },
    },
    mounted() {
        this.$store.dispatch('getEmployees');
        this.$store.dispatch('getLeaveTypes');
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>

<style>

</style>